import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import React from 'react';
import AppRoutes from "./Approutes";
import { Consumer } from '../store';
import { PrimeReactProvider } from 'primereact/api';

const PrivateRoute = ({ element }) => {
  const isAuthenticated = typeof window !== 'undefined' && localStorage.getItem('dashboardAuth') === 'true';

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return element;
};

export default () => (
  <Consumer>
    {({ language }) => (
      <BrowserRouter>
        <Routes>
          {AppRoutes.map((route, index) => {
            const { element, type, ...rest } = route;
            return (
              <Route
                key={index}
                {...rest}
                element={
                  type === "private"
                    ? <PrivateRoute element={element} />
                    : element
                }
              />
            );
          })}
        </Routes>
      </BrowserRouter>
    )}
  </Consumer>
)
